import { render, staticRenderFns } from "./PromptRestore.vue?vue&type=template&id=276882bc&scoped=true&"
import script from "./PromptRestore.vue?vue&type=script&lang=js&"
export * from "./PromptRestore.vue?vue&type=script&lang=js&"
import style0 from "./PromptRestore.vue?vue&type=style&index=0&id=276882bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276882bc",
  null
  
)

export default component.exports